<template>
  <default-layout>
    <div class="h-full flex flex-col max-w-screen-3xl px-5 py-3">
      <div class="flex items-center mb-4 space-x-3">
        <!-- <img class="h-7 w-7 rounded-full" :src="getProfile.avatar_url" :title="getProfile.name"/> -->
        <div class="text-2xl font-bold font-poppins text-gray-800">My Profile</div>
      </div>
      <div class="bg-white rounded h-full flex-grow border border-solid border-gray-200">
        <div class="flex border-b border-coolGray-200 h-10 ">
          <button v-for="(selectedTab, index) in displayableTabs" :key="index" :class="isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid	border-b mt-0.5 border-primary'] : []"
            class="text-sm text-gray-500  cursor-pointer border-0 px-4"
            @click="goToTab(selectedTab.routeName)"
          >
            {{ selectedTab.title }}
          </button>
        </div>
        <div class="tab-body px-6 py-6">
          <transition>
            <div v-if="getProfile.loading">
              <div class="flex justify-center items-center mb-2">
                <pl-spinner />
              </div>
            </div>
            <router-view v-else></router-view>
          </transition>
        </div>
      </div>
    </div>
    <Enable2FAModal v-if="enableModal2FA" @close="enableModal2FA = false" :type2FA="type2fa"/>
  </default-layout>
</template>

<script>
  import BasicInfoTab from './profileTabs/basicInfoTab.vue';
  import SecurityTab from './profileTabs/SecurityTab.vue';
  import PasswordTab from './profileTabs/passwordTab.vue';
  import MembershipTab from './profileTabs/membershipTab.vue';
  import IntegrationsTab from './profileTabs/integrationsTab.vue';
  import { mapGetters } from 'vuex';
  import defaultLayout from 'layouts/default/default.vue';
  import { EventBus } from 'utils/event-bus';
  import Enable2FAModal from './Enable2FAModal.vue';

  export default {
    data() {
      return {
        tab: 'basic_info',
        enableModal2FA: false,
        type2fa: ''
      };
    },
    components: {
      BasicInfoTab,
      PasswordTab,
      MembershipTab,
      IntegrationsTab,
      SecurityTab,
      defaultLayout,
      Enable2FAModal,
    },
    computed: {
      ...mapGetters(['getProfile']),
      displayableTabs() {
        const tabs = [
          {
            title: 'General',
            name: 'basic_info',
            routeName: 'profile.info',
          },
          {
            title: 'Password',
            name: 'password',
            routeName: 'profile.password',
          },
          {
            title: 'Integrations',
            name: 'integrations',
            routeName: 'profile.integrations',
          },
        ];
        if (this.getProfile.role === 'teacher') {
          tabs.push({
            title: 'Membership',
            name: 'membership',
            routeName: 'profile.membership',
          });
          tabs.push({
            title: 'Security',
            name: 'security',
            routeName: 'profile.security',
          });
        }
        return tabs;
      },
    },
    methods: {
      goToTab(routeName) {
        this.$router.push({ name: routeName });
      },
      isSelectedTab(tabName) {
        return this.$route.name === tabName;
      },
    },
    created() {},
    mounted: async function () {
      EventBus.$on('open-configuration-modal', (type2fa) => {
        this.type2fa = type2fa;
        this.enableModal2FA = true;
      });
    },
  };
</script>
<style scoped lang="stylus">
  .profile-body
    min-height: calc(100vh - 144px);
</style>



// WEBPACK FOOTER //
// profile.vue?60315efa